'use client';

import { useI18n } from '@fshr/context/i18n-context';
import Modal from '../modal';
import Button from '../button';
import { IconAlert } from '../icon';

type ChangeStepModalProps = {
	open: boolean;
	onCancel: () => void;
	onSave: () => void;
	onDiscard: () => void;
};

export const ChangeStepModal = ({ open, onCancel, onSave, onDiscard }: ChangeStepModalProps) => {
	const { t } = useI18n();

	if (!open) return null;

	return (
		<Modal close={onCancel} mobileFullScreen={false} focusContainerClassNames="md:h-auto">
			<div className="flex w-full flex-col items-center spacing-stack-xl pb-[40px]">
				<div className="flex flex-col items-center spacing-stack-l text-center">
					<span className="flex size-10 items-center justify-center rounded-full bg-surface-raised-subtle">
						<IconAlert width={40} height={40} fill="currentColor" />
					</span>
					<div className="flex flex-col items-center">
						<h3 className="text-h3 text-text-heading spacing-heading-s">
							{t('You have unsaved changes.')}
						</h3>
						<p className="text-body2 text-text-primary">
							{t('Save them before you go, or discard to leave without keeping your edits.')}
						</p>
					</div>
				</div>
				<div className="flex w-full md:flex-row flex-col justify-center gap-[20px]">
					<Button type="button" intent="filled" onClick={onSave} className="w-full lg:w-[130px]">
						{t('Save')}
					</Button>
					<Button
						type="button"
						intent="outline"
						onClick={onDiscard}
						className="w-full lg:w-[130px]"
					>
						{t('Discard')}
					</Button>
				</div>
			</div>
		</Modal>
	);
};
